import React, { useRef, useState } from 'react';
import Cross from '../../../../Assets/Modals/closeIcon.svg';

import WhatsAppIcon from '../../../../Assets/Lens/whatsapp.png';
import FacebookIcon from '../../../../Assets/Lens/facebook.png';
import TwitterIcon from '../../../../Assets/Lens/twitter.png';
import LinkedInIcon from '../../../../Assets/Lens/linkedin.png';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from '../../../../Features/lensSlice';
import { useOutsideClickHandler } from '../../../../Hooks/useOutsideClick';

function SharePost() {
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => {
        dispatch(closeModal());
    });

    const selectedPost = useSelector((state) => state.lens.modal.selectedPost);

    const [boxText, setBoxText] = useState('Copy');

    const handleCloseModal = () => {
        dispatch(closeModal());
    }

    const handleWhatsappClick = () => {
        const linkElement = document.querySelector('#link');

        try {
            const whatsappMessage = encodeURIComponent(linkElement.textContent);
            const whatsappURL = `https://web.whatsapp.com/send?text=${whatsappMessage}`;
            window.open(whatsappURL, '_blank');
        }
        catch(err) {
            console.error('Error opening WhatsApp!');
        }
    }

    const handleFacebookClick = () => {
        const linkElement = document.querySelector('#link');

        try {
            const linkToShare = encodeURIComponent(linkElement.textContent);
            const facebookURL = `https://www.facebook.com/sharer/sharer.php?u=${linkToShare}`;
            window.open(facebookURL, '_blank');
        }
        catch(err) {
            console.error('Error opening Facebook!', err);
        }
    }

    const handleTwitterClick = () => {
        const linkElement = document.querySelector('#link');

        try {
            const linkToShare = encodeURIComponent(linkElement.textContent);
            const twitterURL = `https://twitter.com/intent/tweet?url=${linkToShare}`;
            window.open(twitterURL, '_blank');
        }
        catch(err) {
            console.error('Error opening Twitter!', err);
        }
    }

    const handleLinkedInClick = () => {
        const linkElement = document.querySelector('#link');

        try {
            const linkToShare = encodeURIComponent(linkElement.textContent);
            const linkedInURL = `https://www.linkedin.com/sharing/share-offsite/?url=${linkToShare}`;
            window.open(linkedInURL, '_blank');
        }
        catch(err) {
            console.error('Error opening LinkedIn!', err);
        }
    }

    const handleLinkCopy = () => {
        const linkElement = document.querySelector('#link');

        navigator.clipboard.writeText(linkElement.textContent)
        .then(() => {
            setBoxText('Copied');
            setTimeout(() => {
                setBoxText('Copy');
            }, 4000);
        })
        .catch(err => {
            console.error('Error copying link to clipboard:', err);
        });
    }

    return (
        <div ref={wrapperRef} className='w-[44%] p-4 rounded-xl bg-[#FFFFFF] flex flex-col gap-3'>
            <div className="flex items-center justify-between">
                <h1 className='font-semibold text-2xl text-[#121212]'>Share</h1>

                <button onClick={handleCloseModal} className="size-11 flex items-center justify-center">
                    <img src={Cross} alt="" />
                </button>
            </div>

            <div className="flex flex-col gap-4">
                <div className="flex items-center gap-[10px]">
                    {
                        selectedPost?.imageUrls && 
                        <div className="size-[60px] rounded-md overflow-hidden border border-[#EAEAEA]">
                            <img className='size-full object-cover' src={selectedPost?.imageUrls[0]} alt="" />
                        </div>
                    }

                    {
                        selectedPost?.videoUrls && 
                        <div className="size-[60px] rounded-md overflow-hidden border border-[#EAEAEA]">
                            <video className='size-full object-cover' src={selectedPost?.videoUrls}></video>
                        </div>
                    }

                    <div className="flex flex-col gap-1 font-medium w-[calc(100%-70px)]">
                        {selectedPost?.postTitle && <h1 className='text-base text-[#121212]'>{selectedPost.postTitle}</h1>}

                        <p className='text-[14px] leading-6 whitespace-nowrap overflow-hidden text-ellipsis text-[#666666]'>{selectedPost?.postDesc}</p>
                    </div>
                </div>

                <div className="px-4 flex flex-col gap-3">
                    <div className="pb-3 border-b border-[#EAEAEA] flex items-center justify-center gap-10 w-full">
                        <button onClick={handleWhatsappClick} className="bg-[#000000AA] select-none outline-none border-none size-[60px] rounded-full overflow-hidden">
                            <img className='size-full object-cover hover:opacity-80' src={WhatsAppIcon} alt="" />
                        </button>

                        <button onClick={handleFacebookClick} className="bg-[#000000AA] select-none outline-none border-none size-[60px] rounded-full overflow-hidden">
                            <img className='size-full object-cover hover:opacity-80' src={FacebookIcon} alt="" />
                        </button>

                        <button onClick={handleTwitterClick} className="bg-[#000000AA] select-none outline-none border-none size-[60px] rounded-full overflow-hidden">
                            <img className='size-full object-cover hover:opacity-80' src={TwitterIcon} alt="" />
                        </button>

                        <button onClick={handleLinkedInClick} className="bg-[#000000AA] select-none outline-none border-none size-[60px] rounded-full overflow-hidden">
                            <img className='size-full object-cover hover:opacity-80' src={LinkedInIcon} alt="" />
                        </button>
                    </div>

                    <div className="relative px-3 py-4 border border-[#EAEAEA] bg-[#F5F5F5] rounded-[9px]">
                        <p id='link' className='w-[85%] whitespace-nowrap overflow-hidden text-ellipsis font-normal text-base text-[#121212]'>https://www.Hyprcom.in/post/2ii33ieji4i</p>
                    
                        <button onClick={handleLinkCopy} className='outline-none absolute right-3 top-1/2 -translate-y-1/2 bg-primaryColor hover:bg-primaryAccent px-5 py-[10px] rounded-[100px] font-semibold text-base text-buttonText'>{boxText}</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SharePost;
